import * as Types from '../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DualResumeObjectsEnabledQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type DualResumeObjectsEnabledQuery = { __typename?: 'Query', jobSeekerProfileDualResumesEnabled?: { __typename?: 'JobSeekerProfileDualResumesEnabledPayload', allResumesEnabled: boolean } | null };


export const DualResumeObjectsEnabledDocument = gql`
    query DualResumeObjectsEnabled {
  jobSeekerProfileDualResumesEnabled {
    allResumesEnabled
  }
}
    `;

/**
 * __useDualResumeObjectsEnabledQuery__
 *
 * To run a query within a React component, call `useDualResumeObjectsEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useDualResumeObjectsEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDualResumeObjectsEnabledQuery({
 *   variables: {
 *   },
 * });
 */
export function useDualResumeObjectsEnabledQuery(baseOptions?: Apollo.QueryHookOptions<DualResumeObjectsEnabledQuery, DualResumeObjectsEnabledQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DualResumeObjectsEnabledQuery, DualResumeObjectsEnabledQueryVariables>(DualResumeObjectsEnabledDocument, options);
      }
export function useDualResumeObjectsEnabledLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DualResumeObjectsEnabledQuery, DualResumeObjectsEnabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DualResumeObjectsEnabledQuery, DualResumeObjectsEnabledQueryVariables>(DualResumeObjectsEnabledDocument, options);
        }
export function useDualResumeObjectsEnabledSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DualResumeObjectsEnabledQuery, DualResumeObjectsEnabledQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DualResumeObjectsEnabledQuery, DualResumeObjectsEnabledQueryVariables>(DualResumeObjectsEnabledDocument, options);
        }
export type DualResumeObjectsEnabledQueryHookResult = ReturnType<typeof useDualResumeObjectsEnabledQuery>;
export type DualResumeObjectsEnabledLazyQueryHookResult = ReturnType<typeof useDualResumeObjectsEnabledLazyQuery>;
export type DualResumeObjectsEnabledSuspenseQueryHookResult = ReturnType<typeof useDualResumeObjectsEnabledSuspenseQuery>;
export type DualResumeObjectsEnabledQueryResult = Apollo.QueryResult<DualResumeObjectsEnabledQuery, DualResumeObjectsEnabledQueryVariables>;